import React, { useEffect, useState } from "react";
import axios from "../api/axiosInstance";
import { useNavigate } from "react-router-dom";

export default function AdminDeliveryMonitor() {
  const [boys, setBoys] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  /* ---------------- LOAD DELIVERY BOYS ---------------- */
  const loadBoys = async () => {
    try {
      const res = await axios.get("admin/delivery-boys/");
      setBoys(res.data.delivery_boys || []);
    } catch (err) {
      console.error(err);
      alert("Failed to load delivery boys");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadBoys();
    const interval = setInterval(loadBoys, 5000); // auto refresh
    return () => clearInterval(interval);
  }, []);

  /* ---------------- STATUS RESOLVER ---------------- */
  const getStatus = (boy) => {
    if (!boy.is_available) return "busy";
    return "free";
  };

  const statusBadge = (status) => {
    if (status === "free") return "🟢 Free";
    if (status === "busy") return "🔴 Busy";
    return "";
  };

  if (loading) return <p style={{ padding: 20 }}>Loading...</p>;

  return (
    <div style={{ padding: 20 }}>
      <h2>🚚 Delivery Boy Monitoring</h2>

      {boys.length === 0 && <p>No delivery boys found</p>}

      {boys.map((boy) => {
        const status = getStatus(boy);

        return (
          <div
            key={boy.id}
            style={{
              border: "1px solid #ddd",
              borderRadius: 10,
              padding: 15,
              marginBottom: 12,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            {/* LEFT INFO */}
            <div>
              <b>{boy.name}</b> ({boy.phone})
              <div>Status: {statusBadge(status)}</div>
            </div>

            {/* ACTIONS */}
            <div>
              {/* TRACK DELIVERY BOY */}
<button
  onClick={() =>
    navigate(`/admin/delivery-boy-map/${boy.id}`)
  }
  style={{
    padding: "8px 12px",
    background: "#0ea5e9",
    color: "#fff",
    border: "none",
    borderRadius: 6,
    cursor: "pointer",
    marginRight: 10,
  }}
>
  Track
</button>


              {/* ASSIGN ORDER (ONLY IF FREE) */}
              <button
                disabled={status !== "free"}
                style={{
                  padding: "8px 12px",
                  background:
                    status === "free" ? "#16a34a" : "#94a3b8",
                  color: "#fff",
                  border: "none",
                  borderRadius: 6,
                  cursor: status === "free" ? "pointer" : "not-allowed",
                }}
              >
                Assign Order
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
}
